import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Absence, Employee } from 'src/app/shared/models/domain';
import { AppearanceService } from 'src/app/shared/services/appearance.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-absence-crud',
  templateUrl: './absence-crud.component.html',
  styleUrls: ['./absence-crud.component.scss'],
})
export class AbsenceCrudComponent implements OnInit {
  @Input() absence: Absence;
  @Input() context: Context;
  @Input() absences: Absence[] = [];
  public absenceForm: FormGroup;
  private modified: boolean = false;
  public reasons: string[] = [];
  public approvals: Employee[] = [];
  public submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private apperanceService: AppearanceService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private dataService:DataService
  ) { }

  ngOnInit(): void {
    this.apperanceService.getVacation().subscribe((reasons) => (this.reasons = reasons));
    this.context = this.authService.getContextData();
    this.apperanceService.getEmployeeList(this.context.employeeId).subscribe((approvals: Employee[]) => (this.approvals = approvals));
    this.setAbsenceForm(this.absence);
  }

  public setAbsenceForm(absence?: Absence) {
    if (!absence)
      absence = {
        id: null,
        markedFor: {
          id: null,
        },
        fromDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        toDate: null,
        markedOn: new Date(),
        markedBy: this.context.employeeId,
        reason: null,
        remarks: null,
        status: 'APPLIED',
        disabled: false,
      } as Absence;
    this.absenceForm = this.fb.group({
      id: this.fb.control(absence.id, null),
      fromDate: this.fb.control(this.datePipe.transform(absence?.fromDate || '', 'yyyy-MM-dd'), [Validators.required]),
      toDate: this.fb.control(this.datePipe.transform(absence?.toDate || '', 'yyyy-MM-dd'), [Validators.required]),
      markedOn: this.fb.control(this.datePipe.transform(absence?.markedOn || new Date(), 'yyyy-MM-dd'), [Validators.required]),
      reason: this.fb.control(absence?.reason, [Validators.required]),
      status: this.fb.control(absence.status || 'APPLIED'),
      markedBy: this.fb.control(absence.markedBy, [Validators.required]),
      markedFor: this.fb.group({
        id: this.fb.control(absence?.markedFor?.id, [Validators.required]),
      }),
      remarks: this.fb.control(absence.remarks, []),
      disabled: this.fb.control(absence.disabled, []),
    });

    this.absenceForm.valueChanges.subscribe(value => this.modified = true);
  }

  get a() {
    return this.absenceForm.controls;
  }

  get m() {
    return this.a.markedFor as FormGroup;
  }

  public saveAbsence(inProgress?: any) {
    this.submitted = true;
    if (this.absenceForm.valid) {
      let absence: Absence = this.absenceForm.value;
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Absence for ${absence.markedFor.name} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      const empName: string = this.approvals.find(a => a.id === absence?.markedFor?.id)?.name ?? '';
      if (absence.id) {
        this.apperanceService.updateAbsence(absence.id, absence).subscribe({
          next: (response: Absence) => {
            if (response) {
              this.activeModal.close(response);
              this.dataService.reInitNotification();
              this.commonService.setToastr(200, `Absence for ${empName} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.apperanceService.createAbsence(absence).subscribe({
          next: (response: Absence) => {
            if (response) {
              this.activeModal.close(response);
              this.dataService.reInitNotification();
              this.commonService.setToastr(200, `Absence for ${empName} has been applied successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}
